import React, { useState } from "react";
import 'firebase/functions'
import firebase from './config';
import Button from "components/CustomButtons/Button.js";


const GerenciarButton = () => {
  const [loading, setLoading] = useState(false);

  const handlePortalRedirect = async () => {
    const app = firebase.app()
    
    setLoading(true);
    try {
        const functionRef = app
        .functions("southamerica-east1")
        .httpsCallable("ext-firestore-stripe-payments-createPortalLink");
      
      const { data } = await functionRef({
        returnUrl: window.location.origin,
        locale: "auto",
      });

      window.location.assign(data.url);
    } catch (error) {
      console.error("Erro ao redirecionar para o portal do cliente:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button color="primary" onClick={handlePortalRedirect} disabled={loading}>
      {loading ? "Redirecionando..." : "Gerenciar Assinatura"}
    </Button>
  );
};

export default GerenciarButton;